import React, { Fragment } from 'react';
import {
  PROPOSAL_BUNDLE_CATEGORY,
  isHotelProposalBundle,
  isTransportProposalBundle,
  type ProposalBundle,
  type ProposalBundleCategory
} from '../../types/proposalBundles';
import type {
  OnProposalBundleClose,
  OnProposalBundleFeedbackUpdate,
  OnProposalItemSelect
} from '../../types/proposalHandlers';
import TransportCard from './transport/TransportCard';
import HotelCard from './hotel/HotelCard';

interface Props {
  bundles: ProposalBundle[];
  includeTax: boolean;
  onSelect?: OnProposalItemSelect;
  onClose?: OnProposalBundleClose;
  onFeedbackUpdate?: OnProposalBundleFeedbackUpdate;
  disabled?: boolean;
  tripId: number;
  isSpLayout?: boolean;
}

const isTransportCategory = (category: ProposalBundleCategory): boolean => {
  const movementCategories: readonly ProposalBundleCategory[] = [
    PROPOSAL_BUNDLE_CATEGORY.OUTWARD,
    PROPOSAL_BUNDLE_CATEGORY.HOMEWARD,
    PROPOSAL_BUNDLE_CATEGORY.TRANSPORT
  ];
  return movementCategories.includes(category);
};

const ProposalBundleCards = ({
  bundles,
  includeTax,
  onSelect,
  onClose,
  onFeedbackUpdate,
  disabled = false,
  tripId,
  isSpLayout = false
}: Props) => {
  if (bundles.length === 0) {
    return null;
  }

  return (
    <Fragment>
      {bundles.map((bundle, index) => {
        const productNumber = index + 1;

        if (isTransportProposalBundle(bundle) && isTransportCategory(bundle.category)) {
          return (
            <TransportCard
              key={bundle.id}
              bundle={bundle}
              productNumber={productNumber}
              includeTax={includeTax}
              onSelect={onSelect}
              onClose={onClose}
              onFeedbackUpdate={onFeedbackUpdate}
              tripId={tripId}
              disabled={disabled}
              isSpLayout={isSpLayout}
            />
          );
        }

        if (isHotelProposalBundle(bundle)) {
          return (
            <HotelCard
              key={bundle.id}
              bundle={bundle}
              productNumber={productNumber}
              includeTax={includeTax}
              onSelect={onSelect}
              onClose={onClose}
              onFeedbackUpdate={onFeedbackUpdate}
              disabled={disabled}
              tripId={tripId}
              isSpLayout={isSpLayout}
            />
          );
        }

        return null;
      })}
    </Fragment>
  );
};

export default ProposalBundleCards;
